export enum LocalStoragePrefix {
  ReplaceMe = "ReplaceMe",
}
